export default __webpack_public_path__ + "static/media/business-functions-off.49b39665.png";